import React, { useCallback, useRef, useState } from 'react'
import { SLowcodeList, STableActions, SActionBtn } from 'shj-components'
import config from './config'
import { buildingAreaList } from '@/services/customerServices'
import ModalAddOrEditDom from './addOrEdit'
import { authDict } from 'shj-utils'

const buildingArea = (props: any) => {
  const listRef = useRef<any>()
  const [isVisible, setIsVisible] = useState(false)
  const [currentRecord, setCurrentRecord] = useState<any>()

  const fetchList = (values: any) => {
    return new Promise(async (resolve, reject) => {
      try {
        const { current, pageSize, query } = values
        buildingAreaList(current, pageSize, query).then((resp: any) => {
          resolve(resp)
        })
      } catch (e) {
        reject({ success: false })
      }
    })
  }

  const onAdd = useCallback(() => {
    setIsVisible(true)
  }, [])
  const onEdit = useCallback((record: any) => {
    setIsVisible(true)
    setCurrentRecord(record)
  }, [])

  // 刷新
  const reloadFn = () => {
    const {
      current: { reload },
    } = listRef
    reload()
  }
  const extension = {
    request: { fetchList },
    events: { onAdd },
    auth: authDict,
    status: {
      btnDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length <= 0,
    },
    customRender: {
      actionTool(text: any, record: any) {
        return (
          <STableActions>
            <SActionBtn
              // auth="EditBuildingAreaButton"
              onClick={() => onEdit(record)}
            >
              编辑
            </SActionBtn>
          </STableActions>
        )
      },
    },
  }

  return (
    <div>
      <SLowcodeList config={config} ref={listRef} {...extension} />
      {isVisible ? (
        <ModalAddOrEditDom
          record={currentRecord}
          onClose={() => {
            setCurrentRecord(undefined)
            setIsVisible(false)
          }}
          open={isVisible}
          reload={() => listRef.current.reload()}
        />
      ) : null}
    </div>
  )
}
export default buildingArea
